export default __webpack_public_path__ + "static/Bäckerbild 1-2f3280c7192831df514e4626f6e0102b.jpg";